import { makeCRUDSlice } from 'redux/crudCreator';
import { MODEL_NAME, subscriptionsActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, subscriptionsActions);

export default slice.reducer;
